<template>
	<div class="account layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				新建子账号
				<p style="font-size: 14px;color:#FF494C;margin-left:10px;">（每个主账号可以创建2个子账号）</p>
			</div>
		</div>

		<div class="layui-form px16" style="padding:30px;" lay-filter='formTest'>
			<div class="layui-form-item">
				<label class="layui-form-label">手机号</label>
				<div class="layui-input-inline">
					<input type="phone" maxlength="11" name="phones" placeholder="请输入登录手机号" lay-verify="phone" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item" style="display: none;">
				<!--防止自动填充密码框-->
				<input type="password" maxlength="20" name="password0">
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">密&nbsp;&nbsp;码</label>
				<div class="layui-input-inline">
					<input type="password" maxlength="20" name="password3" placeholder="请输入登录密码" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">确认密码</label>
				<div class="layui-input-inline">
					<input type="password" maxlength="20" name="password4" placeholder="请再次输入登录密码" autocomplete="off" class="layui-input">
				</div>
			</div>
			<button class="nextBtns layui-btn pointer zt_color" style="margin-left:90px;width:448px;margin-top:30px;" lay-submit lay-filter="submit">注册</button>
		</div>
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				子账号列表
			</div>
		</div>
		<table class="layui-table align_center layui-form" id="orders" style="width:90%;margin:30px 5% 0;">
			<colgroup>
				<col width="200">
				<col width="350">
				<col width="350">
				<col width="150">
				<col width="250">
			</colgroup>
			<thead>
				<tr>
					<th class="align_center">序号</th>
					<th class="align_center">手机号</th>
					<th class="align_center">创建时间</th>
					<th class="align_center">状态</th>
					<th class="align_center">操作</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item,i) in account" :key="i">
					<td>{{i+1}}</td>
					<td>{{item.account}}</td>
					<td>{{item.time}}</td>
					<td>
						<input type="checkbox" name="switch" lay-skin="switch" :checked='item.status!=4' :value="item.id"><span style="margin-left: 15px;">{{item.status == 4? '冻结' : '启用'}}</span>
					</td>
					<td>
						<button @click="onDelect(item.id)" class="layui-btn zt_color">删除</button>
					</td>
				</tr>
				<tr v-if="account.length == 0">
					<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="5">暂无数据</td>
				</tr>
			</tbody>
		</table>
		<div id="lypages" style="margin-left: 5%;"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				account: []
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['form', 'layer'], () => {
				let forms = layui.form;
				let layer = layui.layer;
				forms.on('submit(submit)', function(data) {
					if(_this.account.length >= 2){
						return false;
					}
					if(!data.field.phones) {
						layer.msg('请输入登录手机号', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					if(!data.field.password3) {
						layer.msg('请输入登录密码', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					if(!data.field.password4) {
						layer.msg('请再次输入登录密码', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					api.addSubAccount({
						token: _this.getCookie('token'),
						account: data.field.phones,
						password: data.field.password3,
						repassword: data.field.password4
					}).then((res) => {
						if(res.code == 1) {
							layer.msg('添加成功', {
								icon: 1,
								anim: 5
							})
							forms.val("formTest", { //formTest 即 class="layui-form" 所在元素属性 lay-filter="" 对应的值
								phones: '',
								password3: '',
								password4: '',
							});
							_this.getData();
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				});
				forms.on('switch', function(e) {
					if(e.elem.checked) {
						_this.onOpen(e.elem.value);
					} else {
						_this.onClose(e.elem.value);
					}
				});
			});
		},
		methods: {
			getData() {
				let _this = this;
				layui.use(['form'], () => {
					let forms = layui.form;
					forms.render();
					api.getSubAccountList({
						token: _this.getCookie('token'),
					}).then((res) => {
						if(res.code == 1) {
							for(let i = 0; i < res.data.length; i++) {
								res.data[i].time = _this.getTimes2(res.data[i].createtime);
							}
							_this.account = res.data;
							setTimeout(() => {
								forms.render();
							}, 100)
						} else {
							_this.account = []
						}
					})
				});
			},
			onClose(id) {
				let _this = this;
				api.closeSubAccount({
					token: _this.getCookie('token'),
					sub_id: id
				}).then((res) => {
					if(res.code == 1) {
						_this.getData();
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
						_this.getData();
					}
				})
			},
			onOpen(id) {
				let _this = this;
				api.openSubAccount({
					token: _this.getCookie('token'),
					sub_id: id
				}).then((res) => {
					if(res.code == 1) {
						_this.getData();
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
						_this.getData();
					}
				})
			},
			onDelect(id) {
				let _this = this;
				layer.open({
					type: 0,
					title: '提示',
					content: '是否确认删除该子账号？',
					btn: ['确认', '取消'],
					btnAlign: 'c',
					resize: false,
					closeBtn: 0,
					skin: 'demo-class',
					yes: function(index, layero) {
						layer.closeAll();
						api.delSubAccount({
							token: _this.getCookie('token'),
							sub_id: id
						}).then((res) => {
							if(res.code == 1) {
								_this.getData();
								layer.msg('删除成功', {
									icon: 1,
									anim: 6
								})
							} else {
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
								_this.getData();
							}
						})
					},
					btn2: function(index, layero) {
						layer.closeAll();
					}
				});
			},
		}
	}
</script>

<style scoped="scoped">
	.account input {
		width: 448px;
	}
	
	#receAddress tr th {
		font-weight: 600;
		font-size: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/components/account.vue